<div class="service" [class.draft]="!parametrizado" [class.inactive]="!ativo">
  <div class="header">
    <div class="title">
      <span class="tags">
        <span class="status" [class.on]="ativo">
          {{ ativo ? "Ativo" : "Inativo" }}
        </span>
        <span class="origin" *ngIf="preCadastroCnae">Pré-cadastro do CNAE</span>
      </span>
      <h3>
        <span class="code" *ngIf="codigoFormatado">{{ codigoFormatado }}</span>
        <span class="code muted" *ngIf="!codigoFormatado"
          >Sem código do serviço</span
        >
        <span class="discriminacao">{{
          service?.nome || service?.discriminacao
        }}</span>
      </h3>
      <p class="cnae-line" *ngIf="service?.nome">
        {{ service?.discriminacao }}
      </p>
      <p class="cnae-line" *ngIf="service?.cnae">CNAE {{ cnaeFormatado }}</p>
    </div>
    <div class="actions">
      <button
        type="button"
        class="btn activate"
        *ngIf="!ativo"
        [disabled]="!parametrizado"
        [title]="
          parametrizado
            ? 'Ativar: passa a aparecer na emissão de NFS-e'
            : 'Complete o cadastro para ativar'
        "
        (click)="toggleAtivo.emit(true)"
      >
        <span class="pi pi-check"></span>
        <span class="label">Ativar</span>
      </button>
      <button
        type="button"
        class="btn deactivate"
        *ngIf="ativo"
        title="Inativar: sai da emissão de NFS-e"
        (click)="toggleAtivo.emit(false)"
      >
        <span class="pi pi-ban"></span>
        <span class="label">Inativar</span>
      </button>
      <button type="button" class="btn edit" (click)="edit.emit()">
        <span class="pi pi-pencil"></span>
        <span class="label">Editar</span>
      </button>
      <button type="button" class="btn remove" (click)="remove.emit()">
        <span class="pi pi-trash"></span>
        <span class="label">Remover</span>
      </button>
    </div>
  </div>

  <p class="draft-badge" *ngIf="!parametrizado">
    <i class="pi pi-exclamation-triangle"></i>
    <span>
      Parametrizar: falta {{ faltantesTexto }}. Complete para poder ativar e
      emitir.
    </span>
  </p>

  <dl class="data">
    <div>
      <dt>Código de tributação</dt>
      <dd>{{ service?.codigoTributacao || "—" }}</dd>
    </div>
    <div>
      <dt>Código NBS</dt>
      <dd>{{ service?.codigoNbs || "—" }}</dd>
    </div>
    <div>
      <dt>Alíquota ISS</dt>
      <dd [class.missing]="!temAliquota">
        {{ temAliquota ? service?.iss?.aliquota + "%" : "—" }}
      </dd>
    </div>
  </dl>

  <p class="dates">
    Editado em {{ service?.updatedAt | date: "dd/MM/yyyy HH:mm" }} · Criado em
    {{ service?.createdAt | date: "dd/MM/yyyy HH:mm" }}
  </p>
</div>
